<template>
  <div style="overflow-x: auto; overflow-y: hidden">
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="30"></v-progress-circular>
    </v-overlay>
    <v-card class="pa-6 ma-6 mb-0" v-if="!isTeacherUser" outlined>
      <div class="filter-wrapper">
        <div class="filter-options">
          <v-row>
            <v-col cols="12" md="6">
              <AutocompleteAcademicLevel
                v-model="academicLevel"
                clear-icon="mdi-close"
                label="Bộ môn"
                item-text="title"
                outlined
                dense
                return-object
                hide-details
                @change="academicLevelChanged"
              />
            </v-col>
            <v-col cols="12" md="6">
              <AutocompleteTeacherCard
                :syncedValue.sync="teacher"
                item-text="name"
                clear-icon="mdi-close"
                label="Giáo viên"
                outlined
                dense
                deletable-chips
                hide-details
                :displaySubjectGroup="true"
                :filter="teacherFilter"
              />
            </v-col>
          </v-row>
        </div>
        <div class="filter-submit">
          <v-btn
            class="search-button"
            height="40"
            color="#0D47A1"
            @click="getTeacherSlots"
            :disabled="!teacher || !teacher.id"
            outlined
          >
            Chọn xem
          </v-btn>
        </div>
      </div>
    </v-card>
    <TimeTableBlankView type="teacher" v-if="!selectedTeacherId" class="ma-6" />
    <TimeTableTable v-if="selectedTeacherId" :teacher="selectedTeacherId" type="teacher" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import TimeTableTable from '../TimeTableTable.vue'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import TimeTableBlankView from '@/modules/timeTable/TimeTableBlankView.vue'
import AutocompleteAcademicLevel from '@/components/basic/input/AutocompleteAcademicLevel'

import { isEmpty, get } from 'lodash-es'

export default {
  components: {
    TimeTableTable,
    TimeTableBlankView,
    AutocompleteTeacherCard,
    AutocompleteAcademicLevel,
  },
  data() {
    return {
      grade: null,
      dialog: false,
      selected: null,
      classData: null,
      tab: null,
      teacher: null,
      selectedTeacherId: '',
      selectedClassFromClass: '',
      createState: false,
      academicLevel: {},
      loading: false,
    }
  },
  computed: {
    ...mapState('timeTable', ['classSlots', 'teacherSlots']),
    ...mapGetters('auth', ['profile', 'role']),

    teacherFilter() {
      const filter = {}
      if (this.academicLevel && this.academicLevel.id) {
        filter.academicLevels = this.academicLevel.id
      }
      return filter
    },
    tabIsFullHeight() {
      return !(
        (this.tab === 0 && !isEmpty(this.selectedClassFromClass)) ||
        (this.tab === 1 && !isEmpty(this.selectedTeacherId))
      )
    },
    isTeacherUser() {
      return this.role.type === 'teacher'
    },
  },
  async mounted() {
    if (this.isTeacherUser) {
      this.selectedTeacherId = this.profile.id
      await this.getTeacherSlots()
    }
  },
  methods: {
    ...mapActions('timeTable', ['setSelectedTeacherId']),
    ...mapActions('lesson', ['fetchLessons']),
    academicLevelChanged(academicLevel) {
      this.academicLevel = academicLevel
      if (academicLevel && academicLevel.id) {
        this.teacher = null
      }
    },
    async getTeacherSlots() {
      try {
        this.loading = true
        this.selectedTeacherId = get(this.teacher, 'id', '') || this.profile.id
        const { start, end } = this.getDateInMonth()
        await this.fetchLessons({ teachers: this.selectedTeacherId, date_gte: start, date_lte: end })
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.loading = false
      }
    },
    getDateInMonth() {
      const start = moment().startOf('month')
      const end = moment().endOf('month')
      return { start: start.toISOString(), end: end.toISOString() }
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
